import { motion } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Container = styled(motion.div)`
  position: relative;
  display: none;

  ${mediaTablet`
    display: block;
  `}
`;

export const Wrapper = styled(motion.div)`
  display: none;
  grid-template-columns: repeat(3, 1fr);

  button {
    :focus-visible {
      outline: ${colors.white} solid 1px;
      outline-offset: 3px;
    }
  }
  ${mediaTablet`
    display: grid;
  `}
`;

export const BackButtonWrapper = styled(motion.div)`
  display: flex;
`;

export const Group = styled(motion.div)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 26rem;
`;

export const ButtonWrapper = styled(motion.div)`
  button {
    gap: 20rem;
  }
`;
export const SkipToContent = styled.a`
  position: fixed;
  padding: 30rem 20rem;
  color: ${colors.white};
  background: ${rgba(colors.taupe, 0.5)};
  top: 0;
  left: 20vw;
  transform: translateY(-100%);
  transition: transform 0.3s;

  &:focus {
    transform: translateY(0%);
  }
  :focus-visible {
    outline: ${colors.white} solid 1px;
    outline-offset: 3px;
  }
`;
